import { ChevronDownIcon } from "@heroicons/react/outline";
import {
  SkillModel,
  SkillStatus,
} from "../../api/models/RecitationSkillsModel";
import { classNames } from "../../helpers";
import React, { useLayoutEffect, useRef, useState } from "react";

type SkillProps = {
  skill: SkillModel;
  children?: React.ReactNode;
  onToggle: (skill: SkillModel) => void;
  isEditable?: boolean;
  colorPrimary?: boolean;
};
export default function Skill(props: SkillProps) {
  const { skill, children, onToggle, isEditable, colorPrimary } = props;
  const [collapseState, setCollapseState] = useState<"+" | "-" | null>(
    !!children ? "+" : null
  );
  const inputRef: any = useRef(null);

  const toggleCollapse = () => {
    if (collapseState === "+") {
      setCollapseState("-");
    } else if (collapseState === "-") {
      setCollapseState("+");
    } else {
      setCollapseState(null);
    }
  };
  useLayoutEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = skill.status === SkillStatus.InProgress;
      inputRef.current.checked = skill.status === SkillStatus.Completed;
    }
  }, [skill.status, skill.subSkills]);
  return (
    <li className="px-4">
      <div
        className={classNames(
          "list-container w-full flex justify-between  items-center py-4 border-b",
          collapseState === "+" ? "border-gray-200" : "border-gray-100"
        )}
      >
        <div className="flex gap-2 items-center">
          <input
            type="checkbox"
            disabled={!isEditable}
            ref={inputRef}
            className={classNames(
              "h-4 w-4 rounded",
              isEditable
                ? "border-gray-300 text-brandblue-600 focus:ring-brandblue-500"
                : colorPrimary
                ? "border-none text-brandblue-400"
                : "border-none text-green-600"
            )}
            onChange={() => onToggle(skill)}
          />
          <span
            className={classNames(
              "text-sm font-normal text-gray-500",
              !!children ? "cursor-pointer" : "",
              !!isEditable && skill.isCompleted && "line-through"
            )}
            onClick={toggleCollapse}
          >
            {skill.name}
          </span>
        </div>
        {!!children && (
          <div
            className="flex gap-2 items-center cursor-pointer"
            onClick={toggleCollapse}
          >
            <p className="text-sm leading-[18px] text-gray-400 font-medium">
              <span>{!!skill?.subSkills && skill?.subSkills.length}</span>
              <span>/</span>
              <span
                className={classNames(
                  "text-base leading-[18px]",
                  isEditable
                    ? "text-brandblue-600"
                    : colorPrimary
                    ? "text-brandblue-400"
                    : "text-green-500"
                )}
              >
                {skill.completedSubSkillsCount}
              </span>
            </p>
            <ChevronDownIcon
              className={classNames(
                `w-6 h-6 text-gray-400`,
                collapseState !== "+" ? "rotate-180" : ""
              )}
            />
          </div>
        )}
      </div>
      {collapseState === "-" && children}
    </li>
  );
}
